import { css } from "lit";

export const discordBoxStyles = css`
	#discord-box {
		display: flex;
		align-items: flex-start;
		position: fixed;
		z-index: 1;
		bottom: 0;
		right: 0;
		width: 200px;
		height: 30px;
		background-color: #F5F7FA;
		padding: 10px;
		border-top-left-radius: var(--card-border-radius);
		column-gap: 10px;
		align-items: center;
	}

	#discord-box #logo {
		height: 29px;
		width: 29px;
	}

	#discord-box #close {
		height: 13px;
		width: 13px;
		align-self: flex-start;
	}

	#discord-box p {
		font-size: 14px;
		line-height: 14px;
		color: black;
		font-weight: bold;
	}

	#discord-box a {
		text-decoration: none;
		color: black;
		border-bottom: 1px solid black;
		display: inline-block;
		height: 12px;
	}

	#discord-box a:visited{
		color: black;
	}

	#close-wrapper {
		border: none;
		background-color: transparent;
	}

	#close:hover {
		cursor: pointer;
	}
`;